import DeleteButton, { DeleteButtonTemplate } from './DeleteButton';

export default DeleteButton;
export { DeleteButtonTemplate };
